import { UiPreferenceValue } from '../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { AddOrderProductMode } from '../../../products/orderProducts.types';
import { AddOrderProductToggleState } from '../orderObjectPage.types';

export const DEFAULT_ADD_ORDER_PRODUCT_TOGGLE_STATE: AddOrderProductToggleState = {
  isOpen: false,
  mode: AddOrderProductMode.COLOR,
};

const ADD_ORDER_PRODUCT_MODES: string[] = Object.values(AddOrderProductMode);

const isAddOrderProductMode = (value: unknown): value is AddOrderProductMode =>
  typeof value === 'string' && ADD_ORDER_PRODUCT_MODES.includes(value);

export const parseAddOrderProductToggleState = (
  value: UiPreferenceValue | null,
): AddOrderProductToggleState | null => {
  if (!value) {
    return null;
  }

  const { isOpen, mode } = value;
  const hasValidIsOpen = typeof isOpen === 'boolean';
  const hasValidMode = isAddOrderProductMode(mode);

  if (!hasValidIsOpen && !hasValidMode) {
    return null;
  }

  return {
    isOpen: hasValidIsOpen ? isOpen : DEFAULT_ADD_ORDER_PRODUCT_TOGGLE_STATE.isOpen,
    mode: hasValidMode ? mode : DEFAULT_ADD_ORDER_PRODUCT_TOGGLE_STATE.mode,
  };
};
